//Install
import React, { Component } from "react";
//Install
import F6J6I9 from "../../../../../Media/Image/009.jpg";

//Element
class Q96F2K extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB jo9c61", href: "https://www.temaselektrik.az" },
            //Element
            React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB p0f390" },
                //Element
                React.createElement("img", { alt: "Baku", title: "Baku", src: F6J6I9, width: "636", height: "auto" })
            ),
            //Element
            React.createElement("div", { className: "S0u16d vR05U6 d721Vx pEO064 a527eB v859j8" },
                //Element
                React.createElement("h6", { className: "S6pt64 pEO064 a527eB c016wi" },
                    //Element
                    "Baku"
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Q96F2K;